import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchChannelStatus = createAsyncThunk("fetchChannelStatus", async ({ identifier }) => {
	const response = await axiosHttp.get(`statuses?keyword=${identifier}`);
	return response.data.data;
});

const GlobalChannelsStatusSlice = createSlice({
	name: "GlobalChannelsStatusSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchChannelStatus.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchChannelStatus.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.page;
			state.total = action.payload.total;
		});
		builder.addCase(fetchChannelStatus.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default GlobalChannelsStatusSlice.reducer;
